export const configProviderSymbol = Symbol('configProvider');
export const localeDataSymbol = Symbol('localeData');
